<template>
  <cube-page :title="title">
    <div slot="content">
      <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true" >
        <el-tab-pane label="全年进度排名" name="top">
        </el-tab-pane>
        <el-tab-pane label="明细数据" name="detail">
        </el-tab-pane>
      </el-tabs>
      <wmq-layout
      v-show="activeName === 'top'"
      ref="top"
      :rootLayoutConfig="topUiConfig" />
      <wmq-layout
        v-show="activeName === 'detail'"
        ref="detail"
        :rootLayoutConfig="detailConfig" />
    </div>
  </cube-page>
</template>

<script>
import uiConfig from '@/config/ui-config/product-cover-by-province-detail-ui-config'
import topUiConfig from '@/config/ui-config/product-cover-by-province-top-ui-config'
import { biData } from '@/api/cube'
import { WmqDashboardCubeDataHelperMixin, CubeDataHandle } from 'wmq-component'
import { get, set } from 'lodash'
import CubePage from '../../components/cube-page'
export default {
  name: 'ProductCoverByProvince',
  components: { CubePage },
  mixins: [WmqDashboardCubeDataHelperMixin],
  data () {
    return {
      activeName: 'top',
      topUiConfig
    }
  },
  mounted () {
    this.$refs[this.activeName].refreshAll()
  },
  provide () {
    console.log(333)
    const that = this
    return {
      requestHandler: function (data, reqObj) {
        reqObj.month = that.$route.query.month
        reqObj = {
          ...that.$route.query,
          ...reqObj
        }
        return biData(data.dataCode, reqObj).then(res => {
          return new Promise((resolve) => {
            resolve(CubeDataHandle.handleCubeData(res.data))
          })
        })
      }
    }
  },
  methods: {
    pushUserLog (text) {
      // 上报操作日志
      this.$store.dispatch('PushUserLog', {
        menu: '全国分析',
        page: this.$route.query.channelType,
        operation: '切换Tab'
      })
    },
    handleClick () {
      this.pushUserLog()
      console.log('this.$route.query', this.$route.query)
      this.$refs[this.activeName].refreshAll()
    }
  },
  computed: {
    title() {
      return get(this.$route, 'query.channelType', '') + '覆盖'
    },
    detailConfig () {
      const height = document.body.clientHeight - 100
      console.log('height', height)
      set(uiConfig, 'schema.0.children.明细数据.layout.pos.h', height)
      return uiConfig
    }
  }
}
</script>

<style scoped>

</style>
